export enum BannerType {
  withActivePlanPostpaid = 'with-active-plan-postpaid',
  withActivePlanCombine = 'with-active-plan-kombinuj',
  withActivePlanPrepaid = 'with-active-plan-prepaid',
  withActivePlanDopunaNet = 'with-active-plan-dopuna-net',
  withActivePlanPrepaidNet = 'with-active-plan-net',
  withoutActivePlanPrepaid = 'without-active-plan-prepaid',
  withoutTariffPlanAndOptionsPrepaid = 'without-tariff-plan-and-options-prepaid',
  expiringAccount = 'expiring-account',
  expiringAccountDopuna = 'grace_topupNet',
  additionalPostpaid = 'additionalInfo_postpaid',
  additionalNet = 'additionalInfo_net',
  fixPostpaidPregled = 'fixPostpaid_Pregled',
  payForAnother = 'payBill_tab',
  topUpCreditCard = 'top-up-credit-card',
  bannerSupportComplaint = 'bannerSupportComplaint',
  bannerSupportRequest = 'bannerSupportRequest',
  bannerSupportIncident = 'bannerSupportIncident',
  bannerAppOverview='bannerAppOverview',
  mSatOverview='mSatOverview',
  hboMax='HBOMaxActive',
  siguranNet='siguranNet',
  siguranNetSmall='siguranNetSmall',
}
